
import { defineComponent } from 'vue';
import SvgRedTag from '@/components/Icons/SvgRedTag.vue';
import SvgPhotoCamera from '@/components/Icons/SvgPhotoCamera.vue';
import SvgMagnifyingGlass from '@/components/Icons/SvgMagnifyingGlass.vue';
import SvgChevronRight from '@/components/Icons/SvgChevronRight.vue';

interface VirtualRedTagOption {
    name: string;
    text: string;
    icon: string;
}

export default defineComponent({
    name: 'VirtualRedTagEntry',
    components: {
        SvgRedTag,
        SvgPhotoCamera,
        SvgMagnifyingGlass,
        SvgChevronRight,
    },
    data: (): { options: VirtualRedTagOption[] } => {
        return {
            options: [
                {
                    name: 'VirtualRedTagScanQr',
                    text: 'Scan Trailer QR Code',
                    icon: 'SvgPhotoCamera',
                },
                {
                    name: 'VirtualRedTagManualEntry',
                    text: 'Manual Entry',
                    icon: 'SvgMagnifyingGlass',
                },
            ],
        };
    },
    methods: {
        selectOption(routeName: string): void {
            this.$router.push({ name: routeName });
        },
    },
});
